import {
    AUTHENTICATING_NETSUITE_REQUEST, AUTHENTICATING_NETSUITE_SUCCEDDED, AUTHENTICATING_NETSUITE_FAILED,
    UPDATING_NETSUITE_REQUEST, UPDATING_NETSUITE_SUCCEDDED, UPDATING_NETSUITE_FAILED,
    FETCHING_NETSUITE_INTEGRATION_REQUEST, FETCHING_NETSUITE_INTEGRATION_SUCCEDDED, FETCHING_NETSUITE_INTEGRATION_FAILED
} from '../../actions/actionTypes.jsx';
import { AUTHORIZING_NETSUITE_FAILED, AUTHORIZING_NETSUITE_REQUEST, AUTHORIZING_NETSUITE_SUCCEDDED } from '../../actions/actionTypes';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  authentication: {
    authenticating: false,
    error: null
  },
  authorization: {
    url: null,
    authorizing: false,
    error: null
  }
};

function netsuiteReducer(state = initialState, action) {
  switch (action.type) {

    case AUTHORIZING_NETSUITE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        authorization: {
          authorizing: true,
          error: null
        }
      })

    case AUTHORIZING_NETSUITE_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        authorization: {
          authorizing: false,
          url: action.payload,
          error: null
        }
      })
    
    case AUTHORIZING_NETSUITE_FAILED:
      return Object.assign({}, state, {
        ...state,
        authorization: {
          authorizing: false,
          error: action.payload
        }
      })   
    
    case AUTHENTICATING_NETSUITE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: true,
          error: null
        }
      })
    case AUTHENTICATING_NETSUITE_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: null
        }
      })
    case AUTHENTICATING_NETSUITE_FAILED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: action.payload
        }
      }) 
    case UPDATING_NETSUITE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_NETSUITE_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_NETSUITE_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })
      case FETCHING_NETSUITE_INTEGRATION_REQUEST:
        return Object.assign({}, state, {
          ...state,
          changes: {
            ...state.changes,
            loading: true
          }
        }) 
      case FETCHING_NETSUITE_INTEGRATION_SUCCEDDED: 
        return Object.assign({}, state, {
          ...state,
          changes: {
            ...state.changes,
            loading: false
          }
        }) 
      case FETCHING_NETSUITE_INTEGRATION_FAILED:
        return Object.assign({}, state, {
          ...state,
          changes: {
            ...state.changes,
            loading: false
          }
        })   
       
    default:
      return state;
  }
}

export { netsuiteReducer };